/* MUNT storefront behaviour */
(function () {
  function store(key, val) {
    try { if (val === undefined) return localStorage.getItem(key); localStorage.setItem(key, val); } catch (e) { return null; }
  }
  var jsonHeaders = { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* 1. Reserve buttons: add to cart and open the drawer, no detour through the product page. v22: sends the selling plan (pay when it ships) if the button carries one. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-munt-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var drawer = document.querySelector('cart-drawer');
    var item = { id: parseInt(btn.dataset.muntAdd, 10), quantity: 1 };
    if (btn.dataset.muntPlan) item.selling_plan = parseInt(btn.dataset.muntPlan, 10);
    var body = { items: [item] };
    if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    var addUrl = (window.routes && window.routes.cart_add_url) || (root + 'cart/add');
    fetch(addUrl, { method: 'POST', headers: jsonHeaders, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { window.location.href = btn.getAttribute('href'); return; }
        if (drawer && res.sections && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ id: res.items && res.items[0] ? res.items[0].id : null, sections: res.sections });
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(function () { window.location.href = btn.getAttribute('href'); })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  });

  /* 2. A/B test on the product page: price inside the add-to-cart button, or not. v22: off when the button carries data-ab-off (it already says "$0 today"). */
  document.addEventListener('DOMContentLoaded', function () {
    var submit = document.querySelector('.product-form__submit');
    if (!submit || submit.hasAttribute('data-ab-off')) return;
    var arm = store('munt_ab_btn_price');
    if (arm !== 'price' && arm !== 'plain') { arm = Math.random() < 0.5 ? 'price' : 'plain'; store('munt_ab_btn_price', arm); }
    document.documentElement.setAttribute('data-ab-btn', arm);
    if (arm === 'price' && !submit.disabled) {
      var label = submit.querySelector('span');
      var priceEl = document.querySelector('.product__info-container .price-item--regular');
      var price = priceEl ? priceEl.textContent.trim() : '';
      if (label && price) label.textContent = label.textContent.trim() + ' — ' + price;
    }
    var sent = false;
    submit.addEventListener('click', function () {
      if (sent) return; sent = true;
      fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: { ab_button_price: arm } }) }).catch(function () {});
    });
  });

  /* 3. v22 · Cart drawer and cart page: show the reservation plan with MUNT wording. PreProduct names the selling plan "Deferred charge pre-order"; its renaming setting didn't reach Shopify (22-oct). */
  var PLAN_FROM = 'Deferred charge pre-order', PLAN_TO = 'Reserve — pay when it ships';
  function fixPlanName() {
    var els = document.querySelectorAll('cart-drawer *, .cart-items *, .cart-item *');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.childElementCount === 0 && el.textContent.trim() === PLAN_FROM) el.textContent = PLAN_TO;
    }
  }
  document.addEventListener('DOMContentLoaded', function () {
    fixPlanName();
    if ('MutationObserver' in window) new MutationObserver(fixPlanName).observe(document.body, { childList: true, subtree: true });
  });
})();
